import {useContext, useEffect, useState} from "react";
import AppContext from "./AppContext";

const useApi = ({alert, defaultErrorMessage}) => {
    const setIsLoading = useContext(AppContext);
    const [data, setData] = useState({});
    const [error, setError] = useState(null);
    const [statusCode, setStatusCode] = useState(0);
    const [call, setCall] = useState(null);

    const errMsg = defaultErrorMessage ? defaultErrorMessage : 'Something went wrong!';

    useEffect(() => {
        const fetchData = async () => {
            setIsLoading(true);
            try {
                const response = await call;
                setStatusCode(response.status);
                switch (response.status) {
                    case 200:
                        const json = await response.json();
                        setData(json);
                        break;
                    case 204:
                        setData({});
                        break;
                    case 400:{
                        const json = await response.json();
                        setError(json.detail);
                        if(alert) alert.error(json.detail);
                        break;
                    }
                    default: {
                        setError(errMsg);
                        if(alert) alert.error(errMsg);
                    }
                }
            } catch (e) {
                setError(errMsg);
                if(alert) alert.error(errMsg);
            } finally {
                setIsLoading(false);
            }
        };

        if (call) {
            fetchData();
        }
    }, [call, setIsLoading]);

    return [{data, statusCode, error}, setCall];
};

export default useApi;